/* eslint-disable*/
import { Box, Button, Divider, Grid, List, ListItem, Paper, Typography } from '@material-ui/core';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import AddCircleOutlineSharpIcon from '@material-ui/icons/AddCircleOutlineSharp';
import { ReactComponent as EditPenIconGreen } from '../../../assets/images/EditPenGreen.svg';
import { SectionUserInfo } from '../../../components/Common';
// import Carousel from "react-simply-carousel";
import {
  closestCenter,
  DndContext,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { arrayMove, rectSortingStrategy, SortableContext } from '@dnd-kit/sortable';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import Carousel from 'react-material-ui-carousel';
import ShowMoreText from 'react-show-more-text';
import { backendLocalUrl, FROM } from '../../../constants/globalConstants';
import useLogin from '../../../hooks/useAuth';
import useCommunityList from '../../../hooks/useCommunityList';
import { getAmenityCategories } from '../../../services/communityService';
import ajax from '../../../utils/ajaxHelper';
import SortableGridItem from './SortableGridItem';
import FilterComponent from './FilterComponent';
import ClubDetailDialog from '../ClubsAndConnections/ClubDetailDialog';

// --- URL Query Param Helpers for Amenity Filter Persistence ---
const AMENITY_FILTER_STORAGE_KEY = 'amenityFilters_';

const serializeAmenityFilters = (filters) => {
  if (!filters || filters.length === 0) return '';
  try {
    const json = JSON.stringify(filters);
    return btoa(unescape(encodeURIComponent(json)));
  } catch (e) {
    console.error('Failed to encode amenity filters', e);
    return '';
  }
};

const deserializeAmenityFilters = (searchStr) => {
  const params = new URLSearchParams(searchStr);
  const raw = params.get('af');
  if (!raw) return [];
  try {
    const json = decodeURIComponent(escape(atob(decodeURIComponent(raw))));
    return JSON.parse(json);
  } catch (e) {
    console.error('Failed to decode amenity filters from URL', e);
    return [];
  }
};

const saveFiltersToStorage = (communityId, filters) => {
  try {
    if (filters && filters.length > 0) {
      sessionStorage.setItem(AMENITY_FILTER_STORAGE_KEY + communityId, JSON.stringify(filters));
    } else {
      sessionStorage.removeItem(AMENITY_FILTER_STORAGE_KEY + communityId);
    }
  } catch (e) {
    // sessionStorage not available
  }
};

const loadFiltersFromStorage = (communityId) => {
  try {
    const raw = sessionStorage.getItem(AMENITY_FILTER_STORAGE_KEY + communityId);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    return [];
  }
};
// --- End URL Query Param Helpers ---

const Amenities = ({ communityInfo, isAccessible, publicView, onCommunityUpdate }) => {
  const communityDetails = communityInfo;
  const location = useLocation();
  const navigate = useNavigate();
  const [amenityCategories, setAmenityCategories] = useState([]);
  /* const userInfo = communityDetails?.ammenitiesInsight?.isAdminEntry
    ? repDetails
    : communityDetails?.userrole[0]; */
  //  const [isEditView, setIsEditView] = useState({ isAccessible });

  const executeOnClick = (isExpanded) => {};

  const { getUserDataToAdmin } = useLogin();
  const { toggleAmenityFeatured } = useCommunityList();
  // Initialize selectedFilters: check URL first, then sessionStorage fallback
  const communityId = communityInfo?.id;
  const initialFiltersFromUrl = deserializeAmenityFilters(location.search);
  const initialFilters =
    initialFiltersFromUrl.length > 0 ? initialFiltersFromUrl : loadFiltersFromStorage(communityId);
  const [selectedFilters, setSelectedFilters] = useState(initialFilters);
  const isInitialMount = useRef(true);

  // Helper: update URL and sessionStorage with current amenity filter state
  const updateUrlParams = useCallback(
    (filters) => {
      // Save to sessionStorage (survives navigation to edit page and back)
      saveFiltersToStorage(communityId, filters);

      const params = new URLSearchParams(location.search);
      const encoded = serializeAmenityFilters(filters);
      if (encoded) {
        params.set('af', encoded);
      } else {
        params.delete('af');
      }
      const searchString = params.toString();
      navigate(`${location.pathname}${searchString ? `?${searchString}` : ''}`, { replace: true });
    },
    [navigate, location.pathname, location.search, communityId],
  );
  const [repDetails, setRepDetails] = useState();
  const [filteredAmenities, setFilteredAmenities] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const { getUserName, sortAmenities } = useCommunityList();

  // Drag and drop state
  const [items, setItems] = useState([]);
  const [activeId, setActiveId] = useState(null);
  // const isAdmin = loggedInUserData?.roleId === 2;

  const [filteredAmenitiesCount, setFilteredAmenitiesCount] = useState(0);

  // Dialog state for amenity details
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedAmenity, setSelectedAmenity] = useState(null);

  // State for toggling featured status
  const [togglingFeaturedId, setTogglingFeaturedId] = useState(null);

  // Handle amenity card click to open dialog
  const handleAmenityClick = (amenity) => {
    // Transform amenity data to match club data structure
    // For multiple types, pass them as an array instead of joining
    const transformedData = {
      clubName: amenity?.amenityName,
      clubCategory: {
        clubCategoryName: amenity?.amenityCategory?.amenityCategoryName,
      },
      clubType: Array.isArray(amenity?.amenityType)
        ? amenity.amenityType // Pass the array of type objects
        : amenity?.amenityType
        ? [amenity.amenityType] // Wrap single type in array
        : [],
      clubDesc: amenity?.amenityDesc,
      clubEmail: 'N/A',
      clubPhone: 'N/A',
      clubAddress: amenity?.amenityAddress,
      clubWebsite: 'N/A',
      clubGallery: amenity?.amenityGallery || [],
    };

    setSelectedAmenity(transformedData);
    setDialogOpen(true);
  };

  // Handle dialog close
  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedAmenity(null);
  };

  // Handle amenity edit - navigate to edit page
  const handleAmenityEdit = (amenityData) => {
    // Find the original amenity from items to get the actual amenity ID
    const originalAmenity = items.find((item) => item.amenityName === amenityData.clubName);
    if (originalAmenity && originalAmenity.id) {
      // Navigate to edit amenity page
      // Route: community-details-edit-add-new-amenity/:from/:id/:amenityId
      window.location.href = `/#/app/community-details-edit-add-new-amenity/${FROM.AMENITIES_LiST}/${communityDetails?.id}/${originalAmenity.id}`;
    } else {
      console.error('Could not find amenity ID for editing');
    }
  };

  // Handle toggle featured status
  const handleToggleFeatured = async (amenity, event) => {
    // Stop event propagation to prevent card click
    if (event) {
      event.stopPropagation();
    }

    if (!amenity || !amenity.id) {
      return;
    }

    setTogglingFeaturedId(amenity.id);
    try {
      const newValue = !amenity.featuredAmenity;

      const result = await toggleAmenityFeatured({
        amenityId: amenity.id,
        featuredAmenity: false,
      });

      // Only remove from list if API call was successful
      if (result?.status === true) {
        // Remove the amenity from the local state immediately after successful API response
        setItems((prevItems) => prevItems.filter((item) => item.id !== amenity.id));
        setFilteredAmenities((prevFiltered) =>
          prevFiltered.filter((item) => item.id !== amenity.id),
        );

        // Trigger community update callback to refresh the entire list in the background
        if (onCommunityUpdate) {
          await onCommunityUpdate();
        }
      } else {
        console.error('Failed to toggle featured status:', result?.message);
      }
    } catch (error) {
      console.error('Error toggling featured status:', error);
    } finally {
      setTogglingFeaturedId(null);
    }
  };

  // Function to calculate potential result count based on selected type filters
  const calculatePotentialResultCount = (filters) => {
    if (filters.length === 0) {
      return communityInfo?.amenities?.length || 0;
    }

    const potentialResults = communityInfo?.amenities?.filter((amenity) => {
      const types = Array.isArray(amenity?.amenityType)
        ? amenity.amenityType.map((t) => t.amenityTypeName)
        : amenity?.amenityType
        ? [amenity.amenityType.amenityTypeName]
        : [];
      return filters.every((filter) => types.includes(filter));
    });

    return potentialResults?.length || 0;
  };

  const handleFilterSelection = (filter) => {
    let newSelectedFilters;
    if (selectedFilters.includes(filter)) {
      // Filter is already selected, so remove it.
      newSelectedFilters = selectedFilters.filter((selected) => selected !== filter);
    } else {
      // Filter is not selected, so add it.
      newSelectedFilters = [...selectedFilters, filter];
    }

    setSelectedFilters(newSelectedFilters);
    document.activeElement.blur();
  };

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterResultClick = () => {
    // If no filters are selected, show all amenities
    if (selectedFilters.length === 0) {
      setFilteredAmenities(sortAmenities(communityInfo?.amenities));
    } else {
      // AND logic: show amenities that match all of the selected type filters
      const filteredAmenitiesArr = communityInfo?.amenities?.filter((amenity) => {
        const types = Array.isArray(amenity?.amenityType)
          ? amenity.amenityType.map((t) => t.amenityTypeName)
          : amenity?.amenityType
          ? [amenity.amenityType.amenityTypeName]
          : [];
        return selectedFilters.every((filter) => types.includes(filter));
      });
      setFilteredAmenities(sortAmenities(filteredAmenitiesArr));
    }

    // Sync filters to URL
    updateUrlParams(selectedFilters);

    // Close the filter popover
    setAnchorEl(null);
  };

  const getRepDetails = async () => {
    try {
      if (communityDetails?.ammenitiesInsight?.repId) {
        const userDataResult = await getUserDataToAdmin({
          userIdd: communityDetails?.ammenitiesInsight?.repId,
        });
        setRepDetails(userDataResult.usersResult);
      }
    } catch (error) {
      console.error('Async function error:', error);
    }
  };

  // useEffect to update the count after filteredAmenities is set
  useEffect(() => {
    if (filteredAmenities && Array.isArray(filteredAmenities)) {
      setFilteredAmenitiesCount(filteredAmenities.length);
    }
  }, [filteredAmenities]);

  const resetFilters = () => {
    setSelectedFilters([]); // Reset the selected filters to an empty array
    setFilteredAmenities(sortAmenities(communityInfo?.amenities));
    // Clear filters from URL
    updateUrlParams([]);
    // The count will be updated automatically by the useEffect that watches filteredAmenities
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    getRepDetails();
  }, [communityDetails]);

  // Remove this useEffect as it's redundant - the count is already updated
  // by the useEffect that watches filteredAmenities changes

  useEffect(() => {
    const allAmenities = communityInfo?.amenities;
    const sortedAmenities = sortAmenities(allAmenities);

    // On initial mount, if there are filters (from URL or sessionStorage), auto-apply them
    if (isInitialMount.current && initialFilters.length > 0 && allAmenities?.length > 0) {
      isInitialMount.current = false;
      const filteredAmenitiesArr = allAmenities?.filter((amenity) => {
        const types = Array.isArray(amenity?.amenityType)
          ? amenity.amenityType.map((t) => t.amenityTypeName)
          : amenity?.amenityType
          ? [amenity.amenityType.amenityTypeName]
          : [];
        return initialFilters.every((filter) => types.includes(filter));
      });
      const sorted = sortAmenities(filteredAmenitiesArr);
      setFilteredAmenities(sorted);
      if (sorted && Array.isArray(sorted)) {
        setFilteredAmenitiesCount(sorted.length);
      }
      // Also sync filters to URL if they came from sessionStorage
      if (initialFiltersFromUrl.length === 0) {
        updateUrlParams(initialFilters);
      }
    } else {
      isInitialMount.current = false;
      setFilteredAmenities(sortedAmenities);
      if (sortedAmenities && Array.isArray(sortedAmenities)) {
        setFilteredAmenitiesCount(sortedAmenities.length);
      }
    }
  }, [communityInfo?.amenities]); // Add dependency to re-run when amenities change
  useEffect(() => {
    const loadAmenityCategories = async () => {
      const resp = await getAmenityCategories({ communityId: communityInfo?.id });
      setAmenityCategories(resp?.usersResult);
    };
    loadAmenityCategories();
  }, []);

  // Initialize items for drag and drop
  useEffect(() => {
    // Always update items when filteredAmenities changes, even if it's empty
    if (filteredAmenities) {
      setItems(sortAmenities(filteredAmenities));
    }
  }, [filteredAmenities]);

  // Drag and drop functionality
  const saveAmenitiesOrder = async (reorderedAmenities) => {
    try {
      const resp = await ajax.post(
        `community/update-amenities-order`,
        {
          reorderedAmenities,
        },
        {
          networkParams: { showLoader: false },
        },
      );
    } catch (err) {
      console.error('❌ Error updating amenity order:', err);
    }
  };

  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));

  const handleDragStart = (event) => {
    setActiveId(event.active.id);
  };

  const handleDragEnd = async (event) => {
    const { active, over } = event;
    setActiveId(null);

    if (!over || active.id === over.id) return;

    const oldIndex = items.findIndex((item) => item?.id === active.id);
    const newIndex = items.findIndex((item) => item?.id === over.id);
    let updatedItems = arrayMove(items, oldIndex, newIndex);
    setItems(updatedItems);

    if (communityInfo?.amenities?.length !== items?.length) {
      // Filtered view - need to update full amenities list
      updatedItems = [...sortAmenities(communityInfo?.amenities)]; // full list

      // Find positions in full list
      const activeIndexFull = updatedItems.findIndex((item) => item?.id === active.id);
      const overIndexFull = updatedItems.findIndex((item) => item?.id === over.id);

      if (activeIndexFull !== -1 && overIndexFull !== -1) {
        updatedItems = arrayMove(updatedItems, activeIndexFull, overIndexFull);
      }
    }

    // Update order numbers
    const reorderedAmenities = updatedItems.map((amenity, index) => ({
      id: amenity.id,
      order: index + 1,
    }));

    await saveAmenitiesOrder(reorderedAmenities);

    // Update parent component if callback provided
    if (onCommunityUpdate) {
      const updatedCommunityInfo = {
        ...communityInfo,
        amenities: updatedItems,
      };
      onCommunityUpdate(updatedCommunityInfo);
    }
  };

  const activeAmenity = activeId ? items.find((item) => item?.id === activeId) : null;

  // Reusable AmenityCard component
  const AmenityCard = ({ amenity, isOverlay = false }) => {
    if (!amenity) return null;

    return (
      <Box
        className="AmenitiesSliderBox"
        onClick={() => !isOverlay && handleAmenityClick(amenity)}
        style={{ cursor: isOverlay ? 'grabbing' : 'pointer' }}
      >
        <Box className="SliderContainer">
          {isAccessible && !publicView && (
            <Button
              className="EditCommonButtonFloatSecond"
              href={`/#/app/community-details-edit-add-new-amenity/${FROM.COMMUNITY_DETAILS}/${communityDetails?.id}/${amenity?.id}`}
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<EditPenIconGreen />}
            >
              Edit
            </Button>
          )}

          <Carousel
            navButtonsAlwaysVisible
            autoPlay={false}
            className="SliderCarousel"
            navButtonsProps={{
              style: { backgroundColor: '#000', padding: '0', opacity: 0.6 },
            }}
            indicatorIconButtonProps={{
              style: { padding: '0px', color: 'rgba(255,255,255,0.6)' },
            }}
            activeIndicatorIconButtonProps={{
              style: { padding: '0px', color: 'rgba(255,255,255,1)' },
            }}
            indicatorContainerProps={{
              style: { marginTop: '0px', position: 'absolute', bottom: '5px' },
            }}
          >
            {amenity.amenityGallery?.length > 0 ? (
              amenity.amenityGallery.map((image, i) => (
                <Paper key={i}>
                  <Box className="CardBannerBox">
                    <img
                      src={
                        window.location.hostname === 'localhost'
                          ? `${backendLocalUrl}/${image.image}`
                          : `api/${image.image}`
                      }
                    />
                  </Box>
                </Paper>
              ))
            ) : (
              <Paper>
                <Box className="CardBannerBox">
                  <img
                    src={
                      window.location.hostname === 'localhost'
                        ? `${backendLocalUrl}/assets/images/NoImage.png`
                        : `api/assets/images/NoImage.png`
                    }
                    alt="No Image"
                  />
                </Box>
              </Paper>
            )}
          </Carousel>
        </Box>

        <Box className="SliderInfoContent">
          <Typography variant="h6" className="AmenitiesCategory">
            {amenity?.amenityCategory?.amenityCategoryName}
          </Typography>
          <Typography variant="h3" className="AmenitiesName">
            {amenity?.amenityName}
          </Typography>

          <Box className="AmenitiesAddess">
            <Typography variant="caption" className="AmenitiesInsightLabel">
              Address
            </Typography>
            <Typography variant="body2" className="AmenitiesInsight">
              {amenity?.amenityAddress || '-'}
            </Typography>
          </Box>

          <Box className="AmenitiesText">
            <Typography variant="caption" className="AmenitiesInsightLabel">
              Description
            </Typography>
            <Typography variant="body2" className="AmenitiesInsight CommonDescription">
              {amenity?.amenityDesc || '-'}
            </Typography>
          </Box>

          {isAccessible && !publicView && !isOverlay && (
            <Button
              className="SelectAmenityButtonSecond"
              variant="outlined"
              color="primary"
              fullWidth
              disabled={togglingFeaturedId === amenity.id}
              onClick={(e) => handleToggleFeatured(amenity, e)}
            >
              {togglingFeaturedId === amenity.id ? 'Updating...' : 'Remove From Featured'}
            </Button>
          )}
        </Box>
      </Box>
    );
  };
  return (
    <Paper className="WhitePaper" component="div">
      <Grid container>
        {/* <Grid item xs={12}>
        </Grid> */}
        <Grid item xs={12} className="BoxHeadingContainer">
          <Typography color="primary" variant="h2" className="BoxHeading">
            Amenities
          </Typography>
        </Grid>
        <If condition={isAccessible && !publicView}>
          {' '}
          <Grid item xs={12}>
            <Grid item xs={12} className="AddAmenityRow">
              <Box className="AddAmenityContentBox">
                <Typography variant="body2" className="AddLabel">
                  Inputting amenities helps users find your community when filtering.
                </Typography>
                <Button
                  className="AddButtonBox"
                  variant="outlined"
                  color="primary"
                  fullWidth
                  href={'/#/app/view-all-amenities/' + communityDetails?.id}
                  // href={`/#/app/community-details-edit-add-new-amenity/${FROM.COMMUNITY_DETAILS}/${communityDetails?.id}/default`}
                  startIcon={<AddCircleOutlineSharpIcon />}
                >
                  Feature An Amenity
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} className="AddAmenityDividerRow">
              <Divider className="DividerCD"></Divider>
            </Grid>
          </Grid>
        </If>
        <If condition={communityDetails?.amenities?.length > 0}>
          <Grid item xs={12}>
            <Box mt={3}>
              <Typography variant="h3" component="h3" color="primary" className="Count">
                Featured
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} className="CommonDetailBoxGrid">
            <FilterComponent
              resultCount={filteredAmenitiesCount}
              selectedFilters={selectedFilters}
              anchorEl={anchorEl}
              open={open}
              filtersGrouped={(() => {
                // Collect all amenity type names present in the actual amenities list
                const existingTypeNames = new Set();
                (communityInfo?.amenities || []).forEach((amenity) => {
                  if (Array.isArray(amenity?.amenityType)) {
                    amenity.amenityType.forEach((t) => {
                      if (t?.amenityTypeName) existingTypeNames.add(t.amenityTypeName);
                    });
                  } else if (amenity?.amenityType?.amenityTypeName) {
                    existingTypeNames.add(amenity.amenityType.amenityTypeName);
                  }
                });
                // Filter categories to only include types that exist in the amenities list
                return (amenityCategories || [])
                  .map((cat) => ({
                    id: cat?.id || cat?.amenityCategoryId,
                    categoryName: cat?.amenityCategoryName,
                    types: (cat?.amenityType || [])
                      .filter((t) => existingTypeNames.has(t.amenityTypeName))
                      .map((t) => ({
                        id: t.id,
                        typeName: t.amenityTypeName,
                      })),
                  }))
                  .filter((cat) => cat.types.length > 0); // Remove empty categories
              })()}
              onFilterClick={handleFilterClick}
              onFilterClose={handleFilterClose}
              onFilterSelection={handleFilterSelection}
              onResetFilters={resetFilters}
              onFilterResultClick={handleFilterResultClick}
              calculatePotentialResultCount={calculatePotentialResultCount}
              title="Amenity Filters"
            />
          </Grid>
        </If>
      </Grid>
      {communityDetails?.amenities?.length > 0 ? (
        <Box className="CommonDetailBoxGridSlider">
          {isAccessible ? (
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragStart={handleDragStart}
              onDragEnd={handleDragEnd}
              onDragCancel={() => setActiveId(null)}
            >
              <SortableContext
                items={items?.map((item) => item?.id)}
                strategy={rectSortingStrategy}
              >
                <Grid container spacing={2} className="DragDropContainer">
                  {(showMore ? items : items?.slice(0, 3))?.map((amenity) => (
                    <SortableGridItem key={amenity?.id} id={amenity?.id}>
                      <AmenityCard amenity={amenity} />
                    </SortableGridItem>
                  ))}
                </Grid>
              </SortableContext>

              <DragOverlay adjustScale style={{ transformOrigin: '0 0' }}>
                {activeAmenity ? (
                  <div
                    style={{
                      cursor: 'grabbing',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                      backgroundColor: 'white',
                    }}
                  >
                    <AmenityCard amenity={activeAmenity} isOverlay />
                  </div>
                ) : (
                  ''
                )}
              </DragOverlay>
            </DndContext>
          ) : (
            <Grid container spacing={2}>
              {(showMore ? items : items?.slice(0, 3))?.map((amenity) => (
                <Grid item xs={12} sm={6} md={4} key={amenity?.id}>
                  <AmenityCard amenity={amenity} />
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      ) : (
        ''
      )}
      {filteredAmenities?.length > 3 && (
        <Grid container>
          <Grid item xs={12} className="ShowButton">
            <Button
              className="ShowHideAllButton"
              startIcon={showMore ? <ExpandLess /> : <ExpandMore />}
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? 'Show Less' : 'Show All'}
            </Button>
          </Grid>
        </Grid>
      )}
      {amenityCategories.length > 0 && (
        <Grid container className="ListActivitiesContainer">
          <Grid item xs={12}>
            <Typography variant="h3" component="h3" color="primary" className="Count">
              More to experience in {communityInfo?.communityNameText || ''}
            </Typography>
            <Divider className="GreenDividerColor ListActivitiesDivider" />
          </Grid>
          {/* Start Loop here for the activities List */}
          {amenityCategories?.map((category) => {
            return (
              <Grid item xs={12} key={category.id}>
                <Typography
                  variant="body2"
                  component="div"
                  className="BlackColor ListActivitiesHeading"
                >
                  {category.amenityCategoryName}:
                </Typography>
                <Box className="ListActivitiesBox">
                  <List component="ul" className="ActivitiesList">
                    {category?.amenityType.map((amenityType) => (
                      <ListItem key={amenityType.id}>{amenityType.amenityTypeName}</ListItem>
                    ))}
                  </List>
                </Box>
              </Grid>
            );
          })}

          {/* End Loop here for the activities List */}
        </Grid>
      )}

      <Grid container>
        {/* {((isAccessible && */}
        {/* {filteredAmenities.length > 0 && (
          <Grid item xs={12} className="ViewButton">
            <Link
              href={'/#/app/view-all-amenities/' + communityDetails?.id}
              underline="none"
              color="primary"
              className="RightFloatBtn"
            >
              View all Amenities
              <Box component="span" marginLeft={1}>
                <ArrowForwardIcon className="" />
              </Box>
            </Link>
          </Grid>
        )} */}
        <If condition={communityDetails?.ammenitiesInsight?.amenityDesc}>
          <Grid
            item
            xs={12}
            className={
              communityDetails?.amenities?.length > 0 || isAccessible ? 'ChatBoxContainer' : ''
            }
          >
            {isAccessible &&
              !publicView &&
              communityDetails?.ammenitiesInsight?.amenityDesc !== '' && (
                <Button
                  className="EditCommonButtonFloat"
                  variant="outlined"
                  color="primary"
                  size="small"
                  startIcon={<EditPenIconGreen />}
                  href={'/#/app/community-details-edit-amenities/' + communityDetails?.id}
                >
                  Edit
                </Button>
              )}
            <Box className="ChatBox CommonDetailBoxGrid">
              {communityDetails?.ammenitiesInsight && (
                <Box className="ChatContent">
                  <Typography variant="body2" className="ChatText" color="primary">
                    {communityDetails?.ammenitiesInsight?.amenityDesc?.length > 700 ? (
                      <ShowMoreText
                        lines={3}
                        more="Show More"
                        less="Show Less"
                        className="ReadMoreBox NoArrow"
                        anchorClass="show-more-less-clickable"
                        onClick={executeOnClick}
                        expanded={false}
                        truncatedEndingComponent={'... '}
                      >
                        {communityDetails?.ammenitiesInsight?.amenityDesc}
                      </ShowMoreText>
                    ) : (
                      communityDetails?.ammenitiesInsight?.amenityDesc
                    )}
                  </Typography>
                </Box>
              )}

              <SectionUserInfo
                communityDetails={communityDetails}
                repDetails={repDetails}
                isAdminEntry={communityDetails?.ammenitiesInsight?.isAdminEntry}
                getUserNameFunction={getUserName}
              />
            </Box>
          </Grid>
        </If>
        {isAccessible && !publicView && (
          <>
            <Grid item xs={12}>
              {isAccessible && !publicView && !communityDetails?.ammenitiesInsight?.amenityDesc && (
                <Box>
                  <Typography variant="body2" className="InsightLabel">
                    Here’s where you can describe your community’s amenities. Are there amenities
                    that make your community stand out or contribute to a sense of belonging?
                  </Typography>
                </Box>
              )}
            </Grid>
          </>
        )}
      </Grid>
      <If
        condition={isAccessible && !publicView && !communityDetails?.ammenitiesInsight?.amenityDesc}
      >
        <Grid item xs={12}>
          <div className="Wrapper ButtonWrapper InsightButtonContainer">
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              href={'/#/app/community-details-edit-amenities/' + communityDetails?.id}
            >
              {communityDetails?.ammenitiesInsight?.amenityDesc ? ' Edit' : ' Add'}
              <Box className="AddButton">Insight</Box>
            </Button>
          </div>
        </Grid>
      </If>

      {/* Amenity Detail Dialog */}
      <ClubDetailDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        clubData={selectedAmenity}
        publicView={publicView}
        isAccessible={isAccessible}
        onEdit={handleAmenityEdit}
      />
    </Paper>
  );
};

export default Amenities;
